export default function authHeader() {
  const token = JSON.parse(localStorage.getItem("token"));

  if (token && token.auth_token) {
    return {
      Accept: "application/json",
      Authorization: "Token " + token.auth_token,
    };
  } else {
    return {};
  }
}
